import LegalPage from "./LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      title="Refund Policy"
      subtitle="Refund terms for credits and payments."
      sections={[
        {
          heading: "Credit Purchase",
          text: "Credits once purchased are added to your ShipLess AI wallet and can be used for image optimization.",
        },
        {
          heading: "Refund Eligibility",
          text: "Refunds may be considered only in cases of payment gateway error.",
        },
        {
          heading: "Non-Refundable Usage",
          text: "Credits used for successful image optimization are non-refundable.",
        },
        {
          heading: "Refund Timeline",
          text: "Approved refunds may take 5–7 working days depending on the payment provider.",
        },
        {
          heading: "Contact",
          text: "For refund requests, contact support@shipless.in with payment ID and registered email.",
        },
      ]}
    />
  );
}